module.exports = __webpack_public_path__ + "img/compact&dark.675e88dd.jpg";